"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledText = exports.HotelTariffOffer = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _localization = require("@lt/localization");

var _tagTypes = require("../../HotelCardTag/utils/tagTypes");

var _MobilePopupBottom = _interopRequireDefault(require("../../MobilePopupBottom"));

var _CurrencyFormat = _interopRequireDefault(require("../../CurrencyFormat"));

var _HotelOfferButton = _interopRequireDefault(require("../../HotelOfferButton/HotelOfferButton"));

var _userflow = require("../../../icons-react/userflow");

var _symbols = require("../../../constants/symbols");

var _HotelCardTag = _interopRequireDefault(require("../../HotelCardTag/HotelCardTag"));

var _utils = require("../../CancellationPolicy/assets/utils");

var _types = require("./types");

var _utils2 = require("./utils");

var _NonRefundableCancellation = _interopRequireDefault(require("../../../icons-react/userflow/NonRefundableCancellation"));

var _FreeCancellation = _interopRequireDefault(require("../../../icons-react/userflow/FreeCancellation"));

var _PartialCancellation = _interopRequireDefault(require("../../../icons-react/userflow/PartialCancellation"));

var _CancelledCancellation = _interopRequireDefault(require("../../../icons-react/userflow/CancelledCancellation"));

var _ThumbsUp = _interopRequireDefault(require("../../../icons-react/ThumbsUp"));

var _QuestionCircle = _interopRequireDefault(require("../../../icons-react/QuestionCircle"));

var _Bubble = _interopRequireDefault(require("../../Bubble"));

var _CancellationPolicyMobile = _interopRequireDefault(require("../../CancellationPolicy/CancellationPolicyMobile"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var HotelTariffOffer = function HotelTariffOffer(_ref) {
  var _ref$hasSuperCashback = _ref.hasSuperCashback,
      hasSuperCashback = _ref$hasSuperCashback === void 0 ? false : _ref$hasSuperCashback,
      onOfferClicked = _ref.onOfferClicked,
      tourists = _ref.tourists,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      offer = _ref.offer,
      _ref$isMobile = _ref.isMobile,
      isMobile = _ref$isMobile === void 0 ? false : _ref$isMobile;
  var price = offer.price,
      extras = offer.extras,
      nights_count = offer.nights_count,
      availability = offer.availability,
      rates = offer.rates,
      start_date = offer.start_date;
  var oldPrice = extras === null || extras === void 0 ? void 0 : extras.previous_price;

  var _useCurrency = (0, _localization.useCurrency)(),
      code = _useCurrency.code;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      isActive = _useState2[0],
      setActive = _useState2[1];

  var hotPrice = extras === null || extras === void 0 ? void 0 : extras.cheap;
  var isBestPrice = extras === null || extras === void 0 ? void 0 : extras.best_price;
  var isInstantConfirm = Boolean(extras === null || extras === void 0 ? void 0 : extras.instant_confirm);

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      showPopup = _useState4[0],
      setShowPopup = _useState4[1];

  var openPopup = function openPopup() {
    return setShowPopup(true);
  };

  var closePopup = function closePopup() {
    return setShowPopup(false);
  };

  var _rates$cancellation_p = rates.cancellation_policy,
      _rates$cancellation_p2 = _rates$cancellation_p.stages,
      stages = _rates$cancellation_p2 === void 0 ? [] : _rates$cancellation_p2,
      _rates$cancellation_p3 = _rates$cancellation_p.cancelated_at,
      cancellationDateISO = _rates$cancellation_p3 === void 0 ? undefined : _rates$cancellation_p3;

  var cancellationPolicyWithStartDate = _objectSpread(_objectSpread({}, rates.cancellation_policy), {}, {
    flight_date: start_date
  });

  var intervalledStages = (0, _utils.getIntervaledStages)(stages, start_date, cancellationDateISO || new Date().toISOString());
  var currentStage = (0, _utils.getCurrentStage)(intervalledStages);
  var currentReturnType = currentStage === null || currentStage === void 0 ? void 0 : currentStage.return_type;
  var refundType = _types.RETURN_TYPE[currentReturnType].type;
  var refundText = _types.RETURN_TYPE[currentReturnType].text;
  var cancellationPolicyDescription = (0, _utils2.getCancellationPolicyDescription)(currentStage === null || currentStage === void 0 ? void 0 : currentStage.return_type, currentStage === null || currentStage === void 0 ? void 0 : currentStage.end_date);

  var getIconForReturnType = function getIconForReturnType() {
    if (cancellationDateISO) return /*#__PURE__*/_react["default"].createElement(_CancelledCancellation["default"], null);

    switch (currentStage === null || currentStage === void 0 ? void 0 : currentStage.return_type) {
      case 'full':
        return /*#__PURE__*/_react["default"].createElement(_FreeCancellation["default"], null);

      case 'partial':
        return /*#__PURE__*/_react["default"].createElement(_PartialCancellation["default"], null);

      case 'nothing':
        return /*#__PURE__*/_react["default"].createElement(_NonRefundableCancellation["default"], null);

      default:
        return null;
    }
  };

  var icon = getIconForReturnType();
  return /*#__PURE__*/_react["default"].createElement(StyledHotelTariffOffer, {
    isActive: isActive,
    isBestPrice: isBestPrice,
    className: className,
    onMouseEnter: function onMouseEnter() {
      return setActive(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setActive(false);
    },
    isMobile: isMobile
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_HotelCardTag["default"], {
    text: refundText,
    type: refundType
  }), /*#__PURE__*/_react["default"].createElement(StyledCancellationPolicyDescription, {
    returnType: currentStage === null || currentStage === void 0 ? void 0 : currentStage.return_type,
    isMobile: isMobile
  }, cancellationPolicyDescription, (currentStage === null || currentStage === void 0 ? void 0 : currentStage.return_type) === 'full' ? /*#__PURE__*/_react["default"].createElement(StyledFullRefundIcon, null, icon) : /*#__PURE__*/_react["default"].createElement(StyledIcon, null, icon), isMobile ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(StyledQuestionPopup, {
    onClick: openPopup
  }, /*#__PURE__*/_react["default"].createElement(_QuestionCircle["default"], null)), /*#__PURE__*/_react["default"].createElement(_MobilePopupBottom["default"], {
    onClick: closePopup,
    visible: showPopup
  }, /*#__PURE__*/_react["default"].createElement(_CancellationPolicyMobile["default"], {
    data: cancellationPolicyWithStartDate,
    isHotelOnly: true,
    isMobilePopupComponent: true
  }))) : /*#__PURE__*/_react["default"].createElement(StyledBubble, {
    renderExtras: function renderExtras() {
      return /*#__PURE__*/_react["default"].createElement(_CancellationPolicyMobile["default"], {
        data: cancellationPolicyWithStartDate,
        isHotelOnly: true
      });
    },
    placement: "top",
    width: "max",
    text: " "
  }, /*#__PURE__*/_react["default"].createElement(StyledQuestionIcon, {
    returnType: currentStage === null || currentStage === void 0 ? void 0 : currentStage.return_type
  }, /*#__PURE__*/_react["default"].createElement(_QuestionCircle["default"], null))), isBestPrice ? /*#__PURE__*/_react["default"].createElement(StyledBestPrice, null, /*#__PURE__*/_react["default"].createElement(StyledThumbsUp, {
    height: "12px"
  }), "\u041B\u0443\u0447\u0448\u0430\u044F \u0446\u0435\u043D\u0430") : null), !isInstantConfirm && /*#__PURE__*/_react["default"].createElement(StyledHotelCardTag, {
    text: _tagTypes.TYPES.notToConfirmAtOnce.text,
    type: "notToConfirmAtOnce"
  })), /*#__PURE__*/_react["default"].createElement(StyledTariffOfferInfo, null, /*#__PURE__*/_react["default"].createElement(StyledHotelOfferButton, {
    price: price,
    hotPrice: hotPrice,
    hasSuperCashback: hasSuperCashback,
    isActive: isActive || isMobile,
    onClick: function onClick() {
      return onOfferClicked(offer);
    },
    isHotelOnly: true,
    "data-at-hotel-hotel-card": offer.link
  }), oldPrice && /*#__PURE__*/_react["default"].createElement(StyledPriceBreakdownRow, null, /*#__PURE__*/_react["default"].createElement(StyledHotPriceIconWrapper, null, /*#__PURE__*/_react["default"].createElement(StyledHotPriceIcon, null)), /*#__PURE__*/_react["default"].createElement(StyledOldPrice, {
    value: oldPrice,
    currencyCode: code
  })), /*#__PURE__*/_react["default"].createElement(StyledNightsBreakdownRow, null, nights_count, _symbols.MOON, _localization.i18n.t('search.empty.night'), _localization.i18n.t('checkout.people', {
    context: "".concat(tourists)
  })), availability.hotel === 'few' && /*#__PURE__*/_react["default"].createElement(StyledWarningTextRoomsEnd, null, _localization.i18n.t('hotelcard.card.fewHotel'))));
};

exports.HotelTariffOffer = HotelTariffOffer;

var StyledHotelTariffOffer = _styledComponents["default"].div.withConfig({
  displayName: "HotelTariffOffer__StyledHotelTariffOffer",
  componentId: "sc-1rgoeii-0"
})(["", " padding:", ";width:100%;", " background-color:", ";", " display:flex;"], function (_ref2) {
  var isMobile = _ref2.isMobile;
  return !isMobile && 'border-radius: 4px;';
}, function (_ref3) {
  var isMobile = _ref3.isMobile;
  return isMobile ? '8px 0px 16px 8px' : '8px';
}, function (_ref4) {
  var isMobile = _ref4.isMobile;
  return !isMobile && 'min-width: 400px;';
}, function (_ref5) {
  var isActive = _ref5.isActive;
  return isActive ? '#FFFBE5' : '#FFFFFF';
}, function (_ref6) {
  var isBestPrice = _ref6.isBestPrice,
      isActive = _ref6.isActive;
  return isBestPrice && !isActive && 'background-color: #F4F9DF;';
});

var StyledCancellationPolicyDescription = _styledComponents["default"].div.withConfig({
  displayName: "HotelTariffOffer__StyledCancellationPolicyDescription",
  componentId: "sc-1rgoeii-1"
})(["margin-top:2px;color:", ";font-size:12px;width:", "px;"], function (_ref7) {
  var returnType = _ref7.returnType;
  return returnType === 'full' ? '#17181a' : '#4D4D4D';
}, function (_ref8) {
  var isMobile = _ref8.isMobile;
  return isMobile ? '140' : '240';
});

var StyledTariffOfferInfo = _styledComponents["default"].div.withConfig({
  displayName: "HotelTariffOffer__StyledTariffOfferInfo",
  componentId: "sc-1rgoeii-2"
})(["margin-left:auto;width:150px;padding-right:10px;"]);

var StyledHotelOfferButton = (0, _styledComponents["default"])(_HotelOfferButton["default"]).withConfig({
  displayName: "HotelTariffOffer__StyledHotelOfferButton",
  componentId: "sc-1rgoeii-3"
})(["width:140px;"]);

var StyledText = _styledComponents["default"].div.withConfig({
  displayName: "HotelTariffOffer__StyledText",
  componentId: "sc-1rgoeii-4"
})(["display:flex;align-items:center;text-align:center;", " color:", ";width:140px;"], function (props) {
  return props.theme.typography.text3;
}, function (props) {
  return props.theme.colors.greyLight;
});

exports.StyledText = StyledText;
var StyledPriceBreakdownRow = (0, _styledComponents["default"])(StyledText).withConfig({
  displayName: "HotelTariffOffer__StyledPriceBreakdownRow",
  componentId: "sc-1rgoeii-5"
})(["display:flex;justify-content:center;line-height:16px;margin:6px auto;width:80px;background-color:#f9eaec;border-radius:32px;"]);
var StyledNightsBreakdownRow = (0, _styledComponents["default"])(StyledText).withConfig({
  displayName: "HotelTariffOffer__StyledNightsBreakdownRow",
  componentId: "sc-1rgoeii-6"
})(["justify-content:center;margin:6px auto 2px;width:140px;"]);

var StyledWarningTextRoomsEnd = _styledComponents["default"].span.withConfig({
  displayName: "HotelTariffOffer__StyledWarningTextRoomsEnd",
  componentId: "sc-1rgoeii-7"
})(["width:100%;display:flex;justify-content:center;color:#d0021b;font-size:12px;"]);

var StyledHotPriceIconWrapper = _styledComponents["default"].div.withConfig({
  displayName: "HotelTariffOffer__StyledHotPriceIconWrapper",
  componentId: "sc-1rgoeii-8"
})(["position:relative;top:1px;margin-right:3px;"]);

var StyledHotPriceIcon = (0, _styledComponents["default"])(_userflow.HotPriceCircle).withConfig({
  displayName: "HotelTariffOffer__StyledHotPriceIcon",
  componentId: "sc-1rgoeii-9"
})(["height:13px;"]);
var StyledOldPrice = (0, _styledComponents["default"])(_CurrencyFormat["default"]).withConfig({
  displayName: "HotelTariffOffer__StyledOldPrice",
  componentId: "sc-1rgoeii-10"
})(["", " text-decoration:line-through;text-decoration-thickness:0.5px;"], function (props) {
  return props.theme.typography.text3;
});

var StyledIcon = _styledComponents["default"].span.withConfig({
  displayName: "HotelTariffOffer__StyledIcon",
  componentId: "sc-1rgoeii-11"
})(["height:12px;svg{width:12px;height:12px;transform:translate(6px,2px) scale(1.33);}"]);

var StyledFullRefundIcon = _styledComponents["default"].span.withConfig({
  displayName: "HotelTariffOffer__StyledFullRefundIcon",
  componentId: "sc-1rgoeii-12"
})(["height:12px;svg{height:16px;transform:translate(6px,3px) scale(0.9);}"]);

var StyledQuestionIcon = _styledComponents["default"].div.withConfig({
  displayName: "HotelTariffOffer__StyledQuestionIcon",
  componentId: "sc-1rgoeii-13"
})(["svg{stroke:none;circle{stroke:#919499;}path{fill:#919499;}}transform:", ";width:14px;height:14px;"], function (_ref9) {
  var returnType = _ref9.returnType;
  return returnType === 'full' ? 'translate(10px, 1px)' : 'translate(10px, 3px)';
});

var StyledBubble = (0, _styledComponents["default"])(_Bubble["default"]).withConfig({
  displayName: "HotelTariffOffer__StyledBubble",
  componentId: "sc-1rgoeii-14"
})(["display:inline-flex;"]);

var StyledBestPrice = _styledComponents["default"].div.withConfig({
  displayName: "HotelTariffOffer__StyledBestPrice",
  componentId: "sc-1rgoeii-15"
})(["background:#dcf0c8;border-radius:5px;height:20px;width:112px;margin-top:8px;padding:3px 10px;color:#4d4d4d;"]);

var StyledThumbsUp = (0, _styledComponents["default"])(_ThumbsUp["default"]).withConfig({
  displayName: "HotelTariffOffer__StyledThumbsUp",
  componentId: "sc-1rgoeii-16"
})(["> *{stroke:#45bd81;fill:#45bd81;}margin-right:7px;"]);

var StyledQuestionPopup = _styledComponents["default"].div.withConfig({
  displayName: "HotelTariffOffer__StyledQuestionPopup",
  componentId: "sc-1rgoeii-17"
})(["display:inline-block;width:14px;height:14px;margin-left:10px;position:relative;top:3px;svg{stroke:none;circle{stroke:#919499;}path{fill:#919499;}}"]);

var StyledHotelCardTag = (0, _styledComponents["default"])(_HotelCardTag["default"]).withConfig({
  displayName: "HotelTariffOffer__StyledHotelCardTag",
  componentId: "sc-1rgoeii-18"
})(["margin-top:8px;"]);